<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  // mounted() {
  //     window.addEventListener('unload',this.saveState)
  // },
  // methods: {
  //   saveState(){
  //     localStorage.setItem("state",JSON.stringify(this.$store.state))
  //   }
  // },

  created () {
    //在页面加载时读取sessionStorage里的状态信息
    if (localStorage.getItem("store") ) {
        this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(localStorage.getItem("store"))))
    } 

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload",()=>{
        localStorage.setItem("state",JSON.stringify(this.$store.state))
    })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
.houseImg .el-image{
  width: 100% !important;
  height: 100% !important;
}
.wid300 .el-input-group{
  width: 18.75rem !important;
}
.wid300 .el-input-group__append, .el-input-group__prepend{
  background: rgb(245, 56, 56) !important;
  color: #fff !important;
}
/* .please .el-button{
  background: rgb(245, 56, 56);
  color: #fff;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue